import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

function TotalPeople(props) {
    const { title, count } = props;

    // Estilos personalizados com cores mais suaves
    const cardStyle = {
        background: 'linear-gradient(to right, #4682B4 0%, #20B2AA 100%)',  // Gradiente suave
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',  // Sombra leve para profundidade
        borderRadius: '8px',
        color: '#FFFFFF'
    };

    const iconStyle = {
        fontSize: '1.5rem',
        color: '#FFFFFF'
    };

    return (
        <Grid item xs={12} sm={6} md={3}>
            <Card style={cardStyle}>
                <CardContent>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                            {count}
                        </Typography>
                        <TrendingUpIcon style={iconStyle} />
                    </div>
                    <Typography variant="subtitle1" gutterBottom>
                        {title}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default TotalPeople;
